module.exports = __webpack_public_path__ + "img/combo_screenshot_sdy2z7_c_scale,w_1363.e1ff0fcc.png";